import React from "react";
import PropTypes from "prop-types";

export function Flyout({ children, isOpen, ...props }) {
  return isOpen ? <div {...props}>{children}</div> : null;
}

Flyout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  isOpen: PropTypes.bool,
};

Flyout.defaultProps = {
  isOpen: false,
};

Flyout.displayName = "Flyout";

export default Flyout;
